<template>
    <modal
        id="vehicle-information-modal"
        :centered="true"
        :title="$t('shop.vehicleInformationTitle')"
        :show="modal.show"
        :close="modal.close"
        :closeable="modal.closeable"
        size="modal-lg"
    >
        <template>
            <div
                class="modal-body"
                v-for="information in vehicleInformation"
                :key="information"
            >
                <div
                    v-if="information"
                    v-html="information"
                ></div>
            </div>

            <div class="modal-footer justify-content-center row">
                <div class="col-12 text-center">
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click.prevent="hideModal"
                        v-html="$t('generic.close')"
                    ></button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>

export default {
    name: 'VehicleInformationModal',

    props: {
        vehicleInformation: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            modal: {
                show: false,
                close: false,
                closeable: false,
            },
        };
    },

    methods: {
        showModal() {
            this.modal.close = false;
            this.modal.closeable = false;
            this.modal.show = true;
        },

        hideModal() {
            this.modal.show = false;
            this.modal.closeable = true;
            this.modal.close = true;
        },
    },
};
</script>
